// extracted by mini-css-extract-plugin
export default {"root":"AddOtherCredential_root__X1MUG","form":"AddOtherCredential_form__ZaJjE","lastRow":"AddOtherCredential_lastRow__PtdMl","button":"AddOtherCredential_button__3shwk"};